(function (angular) {
	'use strict';

	angular
		.module('iraModule')
		.controller('IraSignupAdditionalInformationForm', [
			'$document',
			'$filter',
			'$timeout',
			'globalConfig',
			'mixpanelFactory',
			'US_STATES',
			'UserFactory',
			IraSignupAdditionalInformationFormFunction
		]);

	function IraSignupAdditionalInformationFormFunction(
		$document,
		$filter,
		$timeout,
		globalConfig,
		mixpanelFactory,
		US_STATES,
		UserFactory) {
		
		var additionalInfo = this;

		additionalInfo.$onInit = function() {
			mixpanelFactory.track('Signup Additional Information IRA Viewed');
			angular.extend(additionalInfo, globalConfig);
			additionalInfo.states = US_STATES;
			additionalInfo.formValues.state = $filter('findSelectedOption')(additionalInfo.formValues.state, 'abbreviation', additionalInfo.states);
		};

		additionalInfo.submit = function() {
			UserFactory.individual.details.save(buildPayload(), additionalInfo.investorProfileForm)
				.then(function(data) {
					additionalInfo.investmentEntityId = data.investmentEntityId;
					$timeout(function() {
						submitForm();
					});
				})
				.catch(function() {
					additionalInfo.formSubmitted = false;
				});
		};

		function buildPayload() {
			var payload = angular.copy(additionalInfo.formValues);

			payload.state = payload.state.abbreviation;

			payload.dateOfBirth = additionalInfo.formattedDob;
			delete payload.year;
			delete payload.month;
			delete payload.day;

			return payload;
		}

		function submitForm() {
			$document[0].getElementById('successfulSubmissionForm').submit();
		}

	}
})(window.angular);